<div>
	<div #calendarNode [ngStyle]="{'max-width': '930px'}"></div>
</div>
